export default {
  MC_PUFFERSON: "McPufferson",
};
